export default function toTime(dateFilter, Authentication) {
  'ngInject';

  return function link(date) {
    const format = Authentication.user?.settings.usTimeFormat ? 'h:mm a' : 'H:mm';
    return dateFilter(date, format);
  };
}
